import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
    },
    inputRoot: {
      position: 'relative',
    },
    inputInput: {
      width: '100%',
      height: rem(46),
      lineHeight: rem(28),
      fontSize: rem(14),
      paddingLeft: rem(14),
      paddingRight: rem(50),
      borderRadius: rem(8),
      backgroundColor: '#fff',
      border: `1px solid ${theme.colors.neutral[2]}`,
      '&:focus': {
        boxShadow: '0px 0px 0px 2px #91caff',
        borderColor: '#2d87f3',
      },
    },
    rightSection: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
    disclaimer: {
      display: 'flex',
      gap: rem(4),
    },
    disclaimerText: {
      fontSize: rem(10),
      lineHeight: rem(16),
    },
    disclaimerIcon: {
      flexShrink: 0,
      marginTop: rem(1),
    },
    input: {},
    submitBtn: {
      width: rem(40),
      backgroundColor: 'transparent',
      '&[data-disabled]': {
        backgroundColor: 'transparent',
        svg: {
          opacity: 0.2,
        },
      },
    },
  }
})
